export default "__VITE_ASSET__Bfr9bdFq__"